<lib-dialog [title]="product?.name" (closeButtonClick)="closeDialog()">
  <div body>
    <h2>{{ product?.promotion?.reason }}</h2>
    <h1 class="highlight-text">{{ discountText }}</h1>

    <div>
      {{
        'product-promotion-dialog.text.from-date-to-date'
          | translate
            : {
                from: product?.promotion?.fromDate | dateParser | dateFormatter,
                to: product?.promotion?.toDate | dateParser | dateFormatter
              }
      }}
    </div>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'product-promotion-dialog.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>
